import {
	ArrowTopRightOnSquareIcon,
	ArrowUpRightIcon,
	BuildingOfficeIcon,
	EnvelopeIcon,
	PencilIcon,
	PhoneIcon,
	ShareIcon,
	UserIcon,
} from '@heroicons/react/24/outline';
import { Link } from '@remix-run/react';
import { GQLOrderFragment } from '@theprintbar/graphql';
import { CrewRoutes, WebRoutes, getFullName, withDomain } from '@theprintbar/shared';
import { ButtonSize, CopyToClipboard, OutlineLinkButton } from 'src/components';

interface CustomerDetailsProps {
	order: GQLOrderFragment;
	billing?: Record<string, any> | null;
	webDomain?: string;
	staff?: boolean;
}

export function CustomerDetails({ order, billing, webDomain, staff }: CustomerDetailsProps) {
	return (
		<div className="text-xs lg:text-sm space-y-2">
			<h5 className="uppercase mb-2 flex items-center gap-2">
				{order.store ? 'Store' : 'Customer'} Details
				{staff && (
					<Link to={'./customer'} className="flex items-center gap-1 p-1">
						<PencilIcon className="w-3 h-3" />
						<span className="normal-case text-xs font-thin underline">Edit</span>
					</Link>
				)}
			</h5>
			{order.store ? (
				<Link className="underline flex items-center gap-2" to={CrewRoutes.Stores.View(order.store.id).Landing}>
					<BuildingOfficeIcon className="w-4 h-4" />
					{order.store.name}
				</Link>
			) : order.user ? (
				<Link className="underline flex items-center gap-2" to={CrewRoutes.Customers.View(order.user.id).Landing}>
					<UserIcon className="w-4 h-4" />
					{getFullName(order.user)}
				</Link>
			) : (
				<p className="flex items-center gap-2 font-bold">
					<UserIcon className="w-4 h-4" />
					Guest
				</p>
			)}

			<a href={`mailto:${order.email}`} className="flex items-center gap-2 underline">
				<EnvelopeIcon className="w-4 h-4" />
				{order.email}
			</a>

			{(order.shippingAddress?.phone || billing?.phone) && (
				<a href={`tel:${order.shippingAddress?.phone || billing?.phone}`} className="flex items-center gap-2 underline">
					<PhoneIcon className="w-4 h-4" />
					{order.shippingAddress?.phone || billing?.phone}
				</a>
			)}

			{!order.store && webDomain && (
				<OutlineLinkButton
					target="_blank"
					size={ButtonSize.XS}
					to={withDomain(WebRoutes.FindMyOrder({ order: order.id, viewId: order.viewId }), webDomain)}
				>
					Customer order page
					<ArrowTopRightOnSquareIcon className="ml-2 w-3 h-3" />
				</OutlineLinkButton>
			)}
		</div>
	);
}
